import { OptionsObject, useSnackbar } from "notistack";
import { useCallback } from "react";

const useKlasisSnackbar = () => {
    const { enqueueSnackbar } = useSnackbar();
    
    const klasisEnqueueSnackbar = useCallback(
      (message: string, options?: OptionsObject): void => {
        enqueueSnackbar(message, {
            anchorOrigin: {
                horizontal: 'center',
                vertical: 'bottom'
            },
            ...options
        });
      },
      []
    )
  
    return {
        klasisEnqueueSnackbar
    };
  }
  
  export default useKlasisSnackbar;